<section>
  <header>
    <h1 auto="implementing-step-3-title">Implementing Phase</h1>
  </header>
  <div class="information-container">
    <div>
      <p><strong>Enact and Monitor Progress</strong></p>
      <p>
        It is important to regularly monitor the progress of the activities within each Critical Initiative.
      </p>
      <p>
        Within each Critical Initiative set the tracking status accordingly. You may also select “Add Comment" to add a comment about each initiative.
      </p>
      <p>
        Use the drop-down menu to narrow your list of Critical Initiative(s) you wish to review or update.
      </p>

    </div>
  </div>
  <div class="explanation-margin">
    <div class="download-guide-container">
      <img class="book-icon pointer" src="assets/images/download-guide-icon.svg" alt="book-icon" (click)="openGuide()">
      <span class="download-tagline pointer" (click)="openGuide()">Download the guide</span> to learn more about <strong>Enact and Monitor Progress</strong>.
    </div>
    <div class="select-initiative-header"><strong>Review your Critical Initiatives displayed below:</strong></div>
    <div class="selection-container">
      <div class="input-error-wrap sans-margin">
        <div class="form-row">
          <div class="control-container">
            <app-priority-dropdown
              [showDates]="true"
              [singleSelection]="false"
              [availableOptions]="selectOptions"
              (valueChangedCallback)="dropdownValueChanged($event)"
              [styleClassAppends]="['default-selector-width']"
              defaultLabel="Select Critical Initiative(s)"
              selectedItemsLabel="Critical Initiatives Selected ({0})"
              selectAllItemsLabel="Select All Critical Initiatives"
              allItemsSelectedLabel="All Critical Initiatives Selected ({0})">
            </app-priority-dropdown>
            <button class="btn btn-primary init-select-btn"
                    [disabled]="!filteredInitiativePriorities || filteredInitiativePriorities.length === 0 || !selectedOptions || selectedOptions.length === 0"
                    (click)="displaySelectedInitiatives()">View</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="filteredInitiativePriorities.length > 0 && getPrioritiesCalled">
    <div *ngFor="let priority of filteredInitiativePriorities; index as priorityIndex;">
      <div class="title-wrapper">
        <div class="priority-title" [style.background-color]="priority.colorCode">{{priority.title}}</div>
      </div>
      <ul class="initiative-list styleless">
        <ng-container *ngFor="let objective of priority.objectives; index as objectiveIndex">
          <ng-container *ngFor="let initiative of objective.initiatives; index as initiativeIndex;">
            <li [ngClass]="{'no-bottom-border': initiative.activities.length === 0 && initiativeIndex === 0}">
              <div class="initiative-container" [ngClass]="{'first-one': initiativeIndex === 0}"
                   [style.border-left-color]="getInitiativeBorderColor(priority.colorCode, initiativeIndex)">
                <div class="flex-right-left">
                  <div>
                    <h4>Critical Initiative</h4>
                  </div>
                  <div>
                    <div class="checkbox-container" *ngIf="permissions.canEditBody">
                      <span><strong>Set tracking status:</strong></span>
                    </div>
                    <p-dropdown auto="status-dropdown"
                                [options]="initiative.initiativeStatus ? assignedStatusOptions : unassignedStatusOptions"
                                [styleClass]="'initiative-status-dropdown ' + getInitiativeStatusColor(initiative)"
                                *ngIf="permissions.canEditBody || initiative.initiativeStatus !== null"
                                [(ngModel)]="initiative.initiativeStatus"
                                [disabled]="!permissions.canEditBody"
                                placeholder="Assign Status"
                                (onChange)="onSelectInitiativeStatus($event, initiative)">
                    </p-dropdown>
                  </div>
                </div>
                <div class="initiative-details">
                  <div class="initiative-details-main">
                    <div class="text hard-break-text">{{initiative.description}}</div>
                    <div class="initiative-sub-details">
                      <div class="initiative-dates">
                        <div *ngIf="initiative.startDate"><strong>Start Date:</strong> {{(initiative.startDate || '') | date:'MM/dd/yyyy'}}</div>
                        <div *ngIf="initiative.endDate"><strong>End Date:</strong> {{(initiative.endDate || '') | date:'MM/dd/yyyy'}}</div>
                      </div>
                      <div><span class="label"><b>Objective:</b></span><span>{{objective.text}}</span></div>
                    </div>
                  </div>
                  <div class="initiative-details-alt">
                    <!-- View Comment Container -->
                    <div *ngIf="(initiative.comment && initiative.comment !== '') && (!expandedCommentLocation || expandedCommentLocation.initiative.initiativeId !== initiative.initiativeId)"
                         class="existing-comment-container">
                      <button
                        *ngIf="!isViewer"
                        auto="upload-delete-btn"
                        class="fa fa-trash pointer"
                        pTooltip="Delete Comment"
                        tooltipStyleClass="subheader-item-tooltip"
                        tooltipPosition="bottom"
                        (click)="deleteCommentForInitiative(objective, initiative)">
                      </button>
                      <button
                        *ngIf="!isViewer"
                        auto="upload-edit-btn"
                        class="fa fa-pencil pointer"
                        pTooltip="Edit Comment"
                        tooltipStyleClass="subheader-item-tooltip"
                        tooltipPosition="bottom"
                        appendTo="body"
                        (click)="editCommentClicked(objective, initiative)">
                      </button>
                      <p class="existing-comment-value break-text">{{initiative.comment}}</p>
                    </div>
                    <!-- Active Add/Edit Comment Container -->
                    <div *ngIf="(expandedCommentLocation && expandedCommentLocation.initiative.initiativeId === initiative.initiativeId)"
                         class="active-add-edit-comment-container">
                      <textarea class="comment-textarea"
                                [(ngModel)]="expandedCommentLocation.comment"
                                [maxlength]="maxCommentLength"></textarea>
                      <div class="remaining-msg">Remaining: {{ commentRemainingChars() }}</div>
                      <div class="active-comment-button-row">
                        <button
                          *ngIf="!isViewer"
                          [disabled]="!expandedCommentLocation.comment || expandedCommentLocation.comment.trim() === ''"
                          type="button"
                          class="btn btn-primary"
                          (click)="expandedCommentLocation.isCreate ? saveCommentForInitiative() : editCommentForInitiative()">
                          Save
                        </button>
                        <button
                          *ngIf="!isViewer"
                          type="button"
                          class="btn btn-alt"
                          (click)="cancelCommentAddEdit()"
                        >Cancel</button>
                      </div>
                    </div>
                    <!-- No Comment Add Button Container -->
                    <div *ngIf="(!initiative.comment || initiative.comment === '') && (!expandedCommentLocation || expandedCommentLocation.initiative.initiativeId !== initiative.initiativeId)"
                         class="add-comment-container">
                      <div class="vertical-spacer top"></div>
                      <div class="center-button-container">
                        <button
                          *ngIf="!isViewer"
                          pTooltip="Add Comment"
                          tooltipPosition="bottom"
                          appendTo="body"
                          type="button"
                          class="btn btn-primary"
                          (click)="addCommentClicked(objective, initiative)"
                        >Add Comment</button>
                      </div>
                      <div class="vertical-spacer bottom"></div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="activities-container">
                <div *ngFor="let activity of initiative.activities; index as activityIndex"
                     class="activity-container"
                     [ngClass]="{'last-one': isLastActivity(initiative.activities, activityIndex)}">
                  <div>
                    <div class="activity-title" [style.border-bottom-color]="priority.colorCode">Activity</div>
                    <div class="activity-description">{{activity.description}}</div>
                  </div>
                  <div class="activity-main-content">
                    <div class="flex-right-left person-launch-date">
                      <div>
                        <b>Person Responsible:</b>{{activity.responsibleStakeHolder}}
                      </div>
                      <div>
                        <b>Launch Date:</b>{{activity.launchDate | date:'MM/dd/yyyy'}}
                      </div>
                    </div>
                    <div class="resources">
                      <div class="title"><b>Resource(s)</b></div>
                      <div class="resources-split-row-container">
                        <div class="financial-resources-data">
                          <span class="financial-resource"><strong>Financial Resources:</strong></span>&nbsp;{{activity.financialResources | currency:'USD':'symbol'}}
                        </div>
                        <div class="sources-of-funding-data hard-break-text">
                          <span class="funding-source"><strong>Source of Funding:</strong></span>&nbsp;{{activity.sourceOfFunding}}
                        </div>
                      </div>
                      <div class="other-text-container hard-break-text">
                        <span><strong>Other:</strong></span>&nbsp;{{activity.otherResources}}
                      </div>
                    </div>
                    <div class="measures-and-targets">
                      <div class="measures no-border-left">
                        <div class="title"
                             [ngClass]="{'add-bottom-border': addMeasuresTitleBorder(activity)}">Activity Measure(s)</div>
                        <ul *ngIf="activity.measure" class="styleless striped-list measure-target-list">
                          <li class="measure-list-item hard-break-text">{{activity.measure}}</li>
                        </ul>
                      </div>
                      <div class="targets no-border-right">
                        <div class="title"
                             [ngClass]="{'add-bottom-border': addTargetsTitleBorder(activity)}">Benchmark(s)</div>
                        <ul class="styleless striped-list measure-target-list">
                          <li *ngFor="let target of activity.activityTargets" class="target-list-item">
                            <div class="target-outcome break-text">{{target.expectedOutcome}}</div>
                            <div class="target-date"><b>Target: {{target.targetDate | date:'MM/dd/yyyy'}}</b></div>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ng-container>
        </ng-container>
      </ul>
    </div>
  </ng-container>
  <ng-container *ngIf="(isLoading$ | async) === false; else loading">
    <ng-container *ngIf="!hasFlags.hasPriorities">
      <div class="empty-message">
        <h1>
          <span class="text">To begin this subphase, complete the Envisioning phase first.</span>
        </h1>
      </div>
    </ng-container>
    <ng-container *ngIf="hasFlags.hasPriorities && !hasFlags.hasInitiatives">
      <div class="empty-message">
        <h1>
          <span class="text">In order to begin this subphase, complete the work in your previous subphases.</span>
        </h1>
      </div>
    </ng-container>
  </ng-container>
  <ng-template #loading>
    <div class="loading-panel">
      <div class='loading-spinner'>
        <i class="fa fa-spinner fa-spin"></i>
      </div>
    </div>
  </ng-template>


  <p-dialog #confirmDeleteDialog styleClass="strategies-confirm-dialog" [modal]="true" [closable]="false"
            appendTo="body">
    <p-header>
      <img src="assets/images/exclamation.svg" alt="Alert">
      <span class="dialog-title">Are You Sure?</span>
    </p-header>
    <div>Are you sure you want to delete {{ itemLabel }}?<br/></div>
    <p-footer>
      <button auto="upload-delete-cancel-btn" class="btn btn-alt" type="button" pButton label="Cancel"
              (click)="confirmDeleteDialog.visible = false">
      </button>
      <button auto="upload-delete-delete-btn" class="btn" type="button" pButton label="Delete"
              (click)="onConfirmDeleteDialogAccept()"></button>
    </p-footer>
  </p-dialog>

</section>
